// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"d8d1a1d9","136":"2cd795c7","586":"8f37da49","972":"44009b0a"}[chunkId] + ".chunk.js";
};